module.exports = __webpack_public_path__ + "img/inventerre-logo.9cd7372b.png";